export default __webpack_public_path__ + "static/media/uitra_x.c4e741ee.png";